export default {
  name: 'Silk Stream',
  // gymId: '5fd7cff72eb93d371e0aa7de',
  email: 'centralcompliance@rmguk.com',
  styles: {
    fontFamily: 'Montserrat',
    primary: '#4a4a49',
    secondary: '#7cb3ca',
    accent: '#939799',
    accentDark: '#4a4a49'
  },
  socialMedia: [
    {
      name: 'facebook',
      url: 'https://www.facebook.com/Team.Fortitude.Fitness.UK'
    },
    {
      name: 'instagram',
      url: 'https://www.instagram.com/team_fortitude_fitness/'
    }
  ],
  googleMaps: { lat: 53.9592279, lng: -1.0781796 },
  isHomepageHeroDark: true,
  locationsPage: {
    showUpcomingEvents: false,
    upcomingEventsClassTypes: ['class', 'induction']
  }
};
